// @flow
import * as React from 'react';
import BoardCollageImage from 'app/common/react/components/profile/ProfileBoardCard/BoardCollageImage';
import { Collage, Mask } from 'gestalt';

type Props = {|
  height: number,
  numCols: 2 | 3 | 4,
  pins: Array<Object>,
  width: number,
|};

const COLLAGE_GUTTER_IN_PX = 2;
const THUMB_SIZE_KEY = '170x';

export default function WideProductGroupCollage({
  height = 200,
  numCols = 3,
  pins = [],
  width = 300,
}: Props) {
  return (
    <Mask shape="rounded" width={width} height={height}>
      <Collage
        columns={numCols}
        cover
        height={height}
        gutter={COLLAGE_GUTTER_IN_PX}
        renderImage={({ index, width, height }) => {
          const pin = pins[index];
          if (!pin) {
            return null;
          }
          const image = pin.images[THUMB_SIZE_KEY];
          return <BoardCollageImage height={height} image={image} width={width} />;
        }}
        width={width}
      />
    </Mask>
  );
}
